import PropTypes from "prop-types";
import { Component } from "react";
import "./alert.scss";
import onClickOutside from "react-onclickoutside";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

export class Alert extends Component {
	constructor(props) {
		super(props);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleClickOutside(event) {
		const { alertClickOutside = true } = this.props;
		event.preventDefault();

		if (alertClickOutside) {
			this.props.onClose();
		}
	}

	render() {
		const {
			alertTitle = "",
			alertMessage = "",
			alertActionNodes = false,
			onConfirm,
			alertSubtitle = "",
		} = this.props;
		const headerNode = alertTitle && (
			<Typography variant={TYPOGRAPHY_VARIANTS.XL2} isBold className="alert__title">
				{alertTitle}
			</Typography>
		);

		return (
			<div className="alert">
				{headerNode}
				<div className="alert__message">
					{alertSubtitle && <div className="alert__subtitle">{alertSubtitle}</div>}
					{alertMessage}
				</div>
				<div className="alert__action">
					{alertActionNodes &&
						alertActionNodes.map((alertActionNode, index) => (
							<div
								onClick={onConfirm}
								className="alert__action__item"
								key={`alert-action-node-${index}`}
							>
								{alertActionNode}
							</div>
						))}
				</div>
			</div>
		);
	}
}

Alert.propTypes = {
	alertTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	alertSubtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	alertMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	alertActionNodes: PropTypes.arrayOf(PropTypes.element),
	alertClickOutside: PropTypes.bool,
	onConfirm: PropTypes.func,
	onClose: PropTypes.func,
};

export default onClickOutside(Alert);
